import { Check } from "lucide-react";

const benefits = [
  "Continuidad terapeutica real entre sesiones",
  "Sus pacientes se involucran con su tratamiento",
  "Menos trabajo administrativo, mas tiempo clinico",
  "Expediente digital seguro y siempre accesible",
  "Control financiero de su practica",
  "Alertas cuando un paciente pierde adherencia",
];

const PHYSIO_IMG =
  "https://images.pexels.com/photos/5473177/pexels-photo-5473177.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Benefits = () => {
  return (
    <section
      data-testid="benefits-section"
      className="py-24 md:py-32 relative overflow-hidden"
    >
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-slate-50 -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_-12px_rgba(0,0,0,0.12)]">
              <img
                src={PHYSIO_IMG}
                alt="Fisioterapeuta con paciente"
                className="w-full h-[400px] md:h-[500px] object-cover"
                loading="lazy"
              />
              {/* Overlay stat card */}
              <div className="absolute bottom-6 left-6 glass-card rounded-xl p-4 flex items-center gap-4">
                <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center">
                  <span className="text-white font-heading font-bold text-lg">85%</span>
                </div>
                <div>
                  <p className="text-xs text-slate-500 font-medium">Adherencia promedio</p>
                  <p className="text-sm font-semibold text-slate-800">
                    de pacientes con portal activo
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="order-1 lg:order-2">
            <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
              Beneficios
            </p>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-6">
              Menos papel, mas resultados clinicos
            </h2>
            <p className="text-base md:text-lg text-slate-500 leading-relaxed mb-10">
              Cuando toda la informacion del paciente vive en un solo lugar y el paciente participa activamente, los resultados mejoran.
            </p>

            <div className="space-y-4">
              {benefits.map((b, i) => (
                <div
                  key={i}
                  data-testid={`benefit-item-${i}`}
                  className="flex items-start gap-3"
                >
                  <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-3.5 h-3.5 text-emerald-600" />
                  </div>
                  <span className="text-base text-slate-700 font-medium">{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
